import { render, staticRenderFns } from "./UserCardNew.vue?vue&type=template&id=001926d6&scoped=true"
import script from "./UserCardNew.vue?vue&type=script&lang=js"
export * from "./UserCardNew.vue?vue&type=script&lang=js"
import style0 from "./UserCardNew.vue?vue&type=style&index=0&id=001926d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001926d6",
  null
  
)

export default component.exports